/* Native scrolling keeps touch gestures, snap points and controls on one track. */
(() => {
  window.GrovaSections.register('product-reviews', '[data-product-reviews]', (root, scope) => {
    const track = root.querySelector('[data-review-track]');
    const slides = [...root.querySelectorAll('[data-review-slide]')];
    const dots = [...root.querySelectorAll('[data-review-dot]')];
    const controls = root.querySelector('[data-review-controls]');
    const previous = root.querySelector('[data-review-previous]');
    const next = root.querySelector('[data-review-next]');
    const status = root.querySelector('[data-review-status]');
    if (!track || !slides.length) return;
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    let current = 0;
    let settleTimer;
    let width = track.clientWidth;

    function select(index, announce = true) {
      current = Math.max(0, Math.min(index, slides.length - 1));
      slides.forEach((slide, i) => {
        slide.setAttribute('aria-hidden', String(i !== current));
        slide.toggleAttribute('inert', i !== current);
      });
      dots.forEach((dot, i) => dot.setAttribute('aria-pressed', String(i === current)));
      previous.disabled = current === 0;
      next.disabled = current === slides.length - 1;
      if (announce) status.textContent = `Review ${current + 1} of ${slides.length}`;
    }
    function slideStep() {
      return track.clientWidth + (parseFloat(getComputedStyle(track).columnGap) || 0);
    }
    function scrollToCurrent(behavior) {
      track.scrollTo({ left: current * slideStep(), behavior });
    }
    function show(index) {
      clearTimeout(settleTimer);
      select(index);
      scrollToCurrent(reducedMotion.matches ? 'instant' : 'smooth');
    }
    function settle() {
      clearTimeout(settleTimer);
      if (!track.clientWidth) return;
      const index = Math.round(track.scrollLeft / slideStep());
      if (index !== current) select(index);
    }
    scope.on(track, 'scroll', () => {
      clearTimeout(settleTimer);
      // Fallback for browsers without scrollend; never change the requested
      // index halfway through a smooth scroll or rapid arrow/dot navigation.
      settleTimer = setTimeout(settle, 160);
    }, { passive: true });
    scope.on(track, 'scrollend', settle);
    scope.on(previous, 'click', () => show(current - 1));
    scope.on(next, 'click', () => show(current + 1));
    dots.forEach((dot, i) => scope.on(dot, 'click', () => show(i)));
    scope.on(controls, 'keydown', (event) => {
      const index = { ArrowLeft: current - 1, ArrowRight: current + 1, Home: 0, End: slides.length - 1 }[event.key];
      if (index === undefined) return;
      event.preventDefault();
      show(index);
      if (event.target.matches('[data-review-dot]')) dots[current].focus();
    });
    // Keep the selected review aligned after rotation, responsive visibility
    // changes or theme-editor resizing. Slide height remains intrinsic to the
    // tallest review, so navigation never moves the surrounding page.
    const resizeObserver = typeof ResizeObserver === 'function' ? new ResizeObserver(() => {
      if (!track.clientWidth || track.clientWidth === width) return;
      width = track.clientWidth;
      clearTimeout(settleTimer);
      scrollToCurrent('instant');
    }) : null;
    resizeObserver?.observe(track);
    select(0, false);
    scrollToCurrent('instant');
    controls.hidden = slides.length < 2;
    scope.on(reducedMotion, 'change', () => {
      if (reducedMotion.matches) scrollToCurrent('instant');
    });
    scope.cleanup(() => {
      clearTimeout(settleTimer);
      resizeObserver?.disconnect();
      controls.hidden = true;
      slides.forEach((slide) => {
        slide.removeAttribute('aria-hidden');
        slide.removeAttribute('inert');
      });
    });
  });
})();
